import React, { useState } from 'react';
import { Button, Tooltip } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import ChartDownloadModal from './ChartDownloadModal';
import { useTranslation } from '../../hooks/useTranslation';

interface ChartDownloadButtonProps {
  chartRef: React.RefObject<HTMLDivElement>;
  title: string;
  subtitle?: string;
}

const ChartDownloadButton: React.FC<ChartDownloadButtonProps> = ({
  chartRef,
  title,
  subtitle,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('market');

  return (
    <>
      <Tooltip content={t('Descargar gráfico')} delay={400}>
        <Button
          size='sm'
          variant='light'
          isIconOnly
          onPress={() => setIsOpen(true)}
        >
          <Icon icon='mdi:download' className='text-xl text-default-500' />
        </Button>
      </Tooltip>
      <ChartDownloadModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        chartRef={chartRef}
        title={title}
        subtitle={subtitle}
      />
    </>
  );
};

export default ChartDownloadButton;
